module.exports = __webpack_public_path__ + "static/media/charlie-chamero-md.1c7824be.webm";